import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useHttp } from '../hooks/http.hook'
import { AuthContext } from '../context/AuthContext'
import { LanguagesContext } from "../context/LanguagesContext";
import { Loader } from './components/Loader'
import { Toaster } from './components/Toaster'
//import { Link } from 'react-router-dom'
import { Dropdown, Button } from 'react-bootstrap'; // { Button, Form, Row, Col, Table } 
//import { FaTrashAlt, FaSave, FaExternalLinkAlt } from 'react-icons/fa';
import { TeamCard } from './users/TeamCard';

import { NewFormBlock } from './components/NewFormBlock';

import './css/ContentPages.css';
import { Roles } from '../hooks/auth.hook';

export const UsersPage = () => {
    const { request, loading, error } = useHttp()
    const { token, client, role } = useContext(AuthContext)
    const { activeLanguage, getCurrentLanguage } = useContext(LanguagesContext)
    const [receivedError, setReceivedError] = useState(error)

    const [teams, setTeams] = useState([])

    // state arrays for clients and officers dropdowns
    const [clients, setClients] = useState([])
    const [officers, setOfficers] = useState([])

    const [selectedClient, setSelectedClient] = useState()
    const [selectedOfficer, setSelectedOfficer] = useState()

    const [lastOfficerTeamsRequested, setLastOfficerTeamsRequested] = useState()

    const [dropdownLessons, setDropdownLessons] = useState([])

    /*  const updateClientHandler = (data, key, val) => {
          const temp = clientUpdateForm
          if (temp.some(item => item.id === data.id)) {
              //console.log("Object found inside the array.");
              setClientUpdateForm(
                  clientUpdateForm => clientUpdateForm.map(
                      item => {
  
                          if (item.id === data.id) {
                              item[key] = val
                          }
                          return item
                      }
                  )
              )
          } else {
              //console.log("Object not found.");
              setClientUpdateForm([...clientUpdateForm, data])
          }
      }*/ // used for update client name on this page

    const fetchClientLessons = useCallback(async (clientId) => {
        let path = `/client/${clientId}/lessons`;

        try {
            const fetched = await request(path, 'GET', null, {
                'x-access-token': token
            })

            // console.log('client_lessons', fetched);
            let clientLessons = fetched?.length ? fetched : [];
            setDropdownLessons(clientLessons)

        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request])

    const fetchClients = useCallback(async () => {
        try {
            const fetched = await request('/client/all', 'GET', null, {
                'x-access-token': token
            })
            if (fetched) {
                //console.log(fetched);
                setClients(fetched)
                if (fetched.length > 0) {
                    setSelectedClient(fetched[0]);
                    await fetchClientLessons(fetched[0].id);
                }
            }
        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, fetchClientLessons])

    // fetch officers of some client

    const fetchOfficers = useCallback(async () => {
        try {
            const fetched = await request(`/user/officer/all`, 'GET', null, {
                'x-access-token': token
            })
            if (fetched) {
                //console.log(fetched);
                setOfficers(fetched);
                if (fetched.length > 0)
                    setSelectedOfficer(fetched[0]);
            }
        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request])

    const fetchTeams = useCallback(async () => {

        let officerId = null;
        if (role === Roles.Admin || role === Roles.Moderator) {
            if (selectedOfficer == null) {
                console.log('officer not selected');
                return;
            }
            else
                officerId = selectedOfficer.id;
        }

        try {
            const teamsData = await request('/team/all/' + (officerId ?? ''), 'GET', null, {
                'x-access-token': token
            })
            if (teamsData) {
                console.log(teamsData);
                setTeams(teamsData);
                setLastOfficerTeamsRequested(selectedOfficer);
            }
        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request, role, selectedOfficer])

    const startPageInit = useCallback(async () => {

        if (client === null && role === Roles.Admin)
            await fetchClients()

        if (role === Roles.Moderator || role === Roles.Admin)
            await fetchOfficers()

        if (client != null) {
            if (role === Roles.Officer || role === Roles.Moderator) {
                await fetchClientLessons(client);
            }

            if (role === Roles.Officer) {
                await fetchTeams();
            }
        }

    }, [client, role, fetchClients, fetchOfficers])
    // warning? its okay, do not change dependencies because of looping

    useEffect(() => {
        startPageInit()
    }, [startPageInit])


    const addTeam = async (nameForm) => {

        if ((role === Roles.Admin || role === Roles.Moderator) && selectedOfficer != null)
            nameForm.officerId = selectedOfficer.id;

        try {
            const newTeamData = await request('/team/add', 'POST', nameForm, {
                'x-access-token': token
            })
            //console.log('error ', error);            
            setTeams([...teams, newTeamData[0]])
        } catch (e) {
            setReceivedError(e)
        }
    }

    const deleteTeam = async (teamId) => {

        try {
            const data = await request(`/team/remove/${teamId}`, 'DELETE', null, {
                'x-access-token': token
            })
            //console.log('error ', error);
            if (Number.isInteger(data?.changed)) {
                setTeams(teams => teams.filter(item => item.id !== teamId))
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeTeam = async (teamForm) => {  // name, index
        try {
            const team = teamForm[0];
            const data = await request(`/team/update/${team.id}`, 'PUT', team, {
                'x-access-token': token
            })

            if (data.changed === 1) {
                setTeams(
                    prevTeams => prevTeams.map(item => {
                        if (item.id === team.id) {
                            const updatedTeam = { ...item };

                            activeLanguage.map((lang_item, index) =>
                                updatedTeam['name_' + lang_item.code] = team['name_' + lang_item.code]
                            )

                            return updatedTeam;
                        }

                        return item;
                    })
                )
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const unifyElementsDropdowns = (elements, selected, action, placeholder) => {
        let getLabel = (element) => element.name ?? element.email ?? element.id ?? 'Some item';
        return (
            <Dropdown className='mr-4' key={placeholder}>
                <Dropdown.Toggle variant="info" id="dropdown-basic">
                    {elements?.length ? (selected ? getLabel(selected) : placeholder) : 'None'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {elements.map((element, index) =>
                        <Dropdown.Item
                            key={index}
                            onClick={() => {
                                action(element)
                            }}
                        >
                            {getLabel(element)}
                        </Dropdown.Item>)}
                </Dropdown.Menu>
            </Dropdown >
        )
    };

    // default value for admin or moderator  
    const clientsDropdown = unifyElementsDropdowns(
        clients,
        selectedClient,
        (client) => {
            setSelectedClient(client);
            setSelectedOfficer(null);
            fetchClientLessons(client.id);
        },
        'Select Client',
        clients?.length ? clients[0] : null);

    const officersDropdown = unifyElementsDropdowns(
        client != null || selectedClient != null ?
            (officers.filter(officer => officer.client_id === client || officer.client_id === selectedClient?.id)) :
            [],
        selectedOfficer,
        setSelectedOfficer,
        'Select Officer');

    const captionDropdownsBlock = () => {
        let toRender = [];
        if (clients?.length)
            toRender.push(clientsDropdown);
        if (officers?.length)
            toRender.push(officersDropdown);

        toRender.push(<Button key='actionButton' variant="outline-secondary" onClick={async () => {
            await fetchTeams();
        }}>Get Teams</Button>);
        return toRender;
    };


    return (
        <>
            {(receivedError) ? <Toaster errors_list={receivedError} error_state={setReceivedError} /> : ''}
            {loading && <Loader />}

            <h3 className="FormTitle">Teams & Users</h3>
            <div className='d-flex flex-row'>{captionDropdownsBlock()}</div><br />

            {role === Roles.Officer || (selectedOfficer != null && lastOfficerTeamsRequested === selectedOfficer) ?
                [<NewFormBlock key='newFormBlock' languageData={getCurrentLanguage()} addAction={addTeam} loadingState={loading} buttonLabel={'Add Team'} placeholderText={"Enter new team name"} />,

                (teams?.length) ?
                    teams.map((team, index) =>
                        <TeamCard key={index} team={team} array={teams} index={index}
                            changeTeamIndex={null} saveTeamNameChanges={changeTeam} deleteTeam={deleteTeam}
                            setReceivedError={setReceivedError} dropdownLessons={dropdownLessons} selectedClient={selectedClient}
                            showAllLanguages={true}
                        />
                    ) :
                    <p className='text-white text-center'>No teams</p>]
                : null}
        </>
    )
}
